angular.module('eStories.grid-title.compnt', [])

    .component('gridTitle', {
        transclude: true,
        bindings: {
            title: '<',
            color: '@',
            white: '<'
        },
        template: `<div class="navbarSubHeadLeft">
                        <div class="carouselTitleText" ng-class="{white: $ctrl.white}">
                            <h1>{{$ctrl.title}}</h1>
                        </div>
                        <div class="carouselTitleLine" ng-style="{'background': $ctrl.color}"></div>
                    </div>`
    });

